import React from 'react';
import {RadioButton} from 'material-ui/RadioButton';
import SelectField from 'components/pure/utils/form/SelectField';
import './RadioSelect.styl';

/**
 * Renders a Radio and SelectField together
 * props:
 *  @options:  options passed to the select field.  Array of {label,value}
 *  @value: selected value.  Must be in options
 *  @checked:  boolean indicating of the Radio button is selected
 *  @label:  text label of the Radio button
 *
 * events:
 *  @valueChanged:  triggered from the SelectField.onChange
 *  @radioClick:  triggered when the RadioButton is clicked
 */
export default class RadioSelect extends React.Component {
  constructor(props) {
    super(props);

    this.valueChanged = this.valueChanged.bind(this);
  }

  valueChanged(value) {
    const {options} = this.props;
    const option = this.getOptionByValue(options, value);
    this.props.valueChanged(value, option);
  }

  getOptionByValue(options, value) {
    if (options) {
      return options.find(option => option.value === value);
    }
  }

  render() {
    const {options, value, checked, label, placeholder, renderOption} = this.props;
    return (
      <div className="radio-select-field" onClick={this.props.radioClick}>
        <div className="radio-wrapper">
          <RadioButton label={label} checked={checked} onClick={this.props.radioClick} />
        </div>
        {options && (
          <SelectField
            disabled={!checked}
            value={checked && value}
            options={options}
            tether={true}
            hideResetButton={true}
            onChange={this.valueChanged}
            placeholder={placeholder}
            renderOption={renderOption}
          />
        )}
      </div>
    );
  }
}
